import react, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { dismissAlert } from "../../reducers/alertSlice";

export default function AlertDialog({ theme }) {
    const dispatch = useDispatch();

    const { open, title, message, buttons } = useSelector(
        (state) => state.alertBox
    );

    const handleClose = () => {
        dispatch(dismissAlert());
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent sx={{ width: { xs: "auto", md: "450px" } }}>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {buttons.map((b, index) => {
                    return (
                        <Button
                            key={`alert-${index}`}
                            onClick={() => {
                                if (!b.callback) {
                                    handleClose();
                                    return;
                                }

                                b.callback();
                                handleClose();
                            }}
                            sx={{ color: theme.palette.color.button }}
                        >
                            {b.label}
                        </Button>
                    );
                })}
            </DialogActions>
        </Dialog>
    );
}
